import { useTokenRefresh } from '@/features/login/hooks/useTokenRefresh';

/**
 * Keeps token refresh hook mounted across route changes.
 * Must live at app shell level (not on login-only pages).
 */
export default function TokenRefreshBootstrap() {
    useTokenRefresh();
    return null;
}
